/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_SubtitleInputs */

const cs_sreality_subtitle = /** @type {(inputs: Sreality_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden RK import pro celou kancelář. Každý makléř přes něj inzeruje. Mění se jen seller persona (jméno na inzerátu).`)
};

const en_sreality_subtitle = /** @type {(inputs: Sreality_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One RK import for the whole office. Every broker posts through it. The only thing that changes per person is the seller persona (their name on the advert).`)
};

/**
* | output |
* | --- |
* | "One RK import for the whole office. Every broker posts through it. The only thing that changes per person is the seller persona (their name on the advert)." |
*
* @param {Sreality_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_subtitle = /** @type {((inputs?: Sreality_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_subtitle(inputs)
	return cs_sreality_subtitle(inputs)
});